var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      class: ["dc-post-grid-load-more", "dc-button", { loading: _vm.loading }],
      on: {
        click: function($event) {
          $event.stopPropagation()
          $event.preventDefault()
          return _vm.loadMore()
        }
      }
    },
    [_vm._v(_vm._s(_vm.label))]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }